import { render, staticRenderFns } from "./type5.vue?vue&type=template&id=684346fe&scoped=true"
import script from "./type5.vue?vue&type=script&lang=js"
export * from "./type5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684346fe",
  null
  
)

export default component.exports